import { getRandomRequestId } from "./utils";

type IAnyFunction = (...args: any) => any;

type ISubscriptionParams = {
  eventName: string;
  data?: Record<string, unknown>;
  handler: IAnyFunction;
};

export class SubscriptionStorage {
  private storageMap: Map<{ handlerId: string; rid: string; eventName: string }, IAnyFunction[]> = new Map();

  public findRidByEvent(eventName: string, data?: Record<string, unknown>): string | undefined {
    const handlerId = this.getHandlerId({ eventName, data });
    return this.findRidByHandlerId(handlerId);
  }

  public isSubscriptionExist(rid: string): boolean {
    for (const [key] of this.storageMap) {
      if (key.rid === rid) {
        return true;
      }
    }
    return false;
  }

  public getEventNameByRid(rid: string): string | undefined {
    for (const [key] of this.storageMap) {
      if (key.rid === rid) {
        return key.eventName;
      }
    }
  }

  public createSubscription(params: ISubscriptionParams): string {
    const handlerId = this.getHandlerId({ eventName: params.eventName, data: params.data });
    const rid = getRandomRequestId();
    this.storageMap.set({ rid: rid, handlerId, eventName: params.eventName }, [params.handler]);
    return rid;
  }

  public addHandlerToSubscription(rid: string, handler: IAnyFunction) {
    for (const [key, handlers] of this.storageMap) {
      if (key.rid === rid) {
        this.storageMap.set(key, [...handlers, handler]);
        return;
      }
    }
  }

  public removeHandlerFromSubscription(rid: string, handler: IAnyFunction) {
    for (const [key, handlers] of this.storageMap) {
      if (key.rid === rid) {
        const handlersFiltered = handlers.filter((h) => h !== handler);
        if (handlersFiltered.length === 0) {
          this.storageMap.delete(key);
        } else {
          this.storageMap.set(key, handlersFiltered);
        }
        return;
      }
    }
  }

  public clear() {
    this.storageMap.clear();
  }

  public findRidByHandler(handler: IAnyFunction): string | undefined {
    for (const [key, handlers] of this.storageMap) {
      if (handlers.find((h) => h === handler)) {
        return key.rid;
      }
    }
  }

  private findRidByHandlerId(handlerId: string): string | undefined {
    for (const key of this.storageMap.keys()) {
      if (key.handlerId === handlerId) {
        return key.rid;
      }
    }
  }

  private getHandlerId(structure: Record<string, unknown>): string {
    return JSON.stringify(structure);
  }
}
